module.exports = __webpack_public_path__ + "0dafea77630311d8b71569459cf6e5ce.svg";